<template>
  <div>
    <div
      v-show="neighborhood !== 'hidden'"
      class="container bg-white mx-auto p-0"
    >
      <NeighborhoodHeader />
    </div>
    <Header />
    <div class="font-Poppins container-fluid" role="group">
      <NuxtPage
        :page-key="route =>
          route.path.startsWith('/lawn-care-locations/')
            ? route.fullPath
            : 'static'"
      />
    </div>
    <Loader v-if="showLoading" />
    <Footer />
    <BackToTop />
  </div>
</template>

<style src="../assets/styles/global.css"></style>

<script setup lang="ts">
import { useStore } from "vuex";
import type { Store } from "vuex/types/index.js";
import type State from "~/domains/store/State";

const { $axios, $config, $metadata } = useNuxtApp();

// Vuex store
const store: Store<State> = useStore();
const showLoading = computed(() => store.state.showLoading);

// Reactive state
const link = ref([]);
const neighborhood = ref("show");

// Methods
// function loadPatronChat(serverHost: string, bus_no: number, poc: string, params: any[]) {
//   icPatronChat.init({
//     serverHost: serverHost,
//     bus_no: bus_no,
//     poc: poc,
//     params: params,
//   });
// }

// Lifecycle hooks
onMounted(async () => {
  $metadata.updateUrlTracking();

  // Fetch icon
  const icon = await $axios
    .get($config.public.sgCmsApi + "icofile/path")
    .then((response) => response.data)
    .catch(() => false);

  if (icon) {
    link.value = [
      {
        hid: "icon",
        rel: "icon",
        type: "image/x-icon",
        href: icon,
      },
    ];
  }

  // Fetch chat widget status
  const statusResponse = await $axios
    .get($config.public.sgCmsApi + "chatwidget/status")
    .then((response) => response)
    .catch((error) => ({ error: error, response: error.response.data }));

  const status = statusResponse.data !== "0";

  if (status) {
    const data = await $axios
      .get($config.public.sgCmsApi + "chatwidget/script")
      .then((response) => response.data)
      .catch((error) => ({ error: error, response: error.response.data }));

    if (store.state.persistedState?.scope?.id) {
      data.params.push(store.state.persistedState.scope.id);
    }

    data.bus_no = Number(data.bus_no);
    // loadPatronChat(data.serverHost, data.bus_no, data.poc, data.params);
  }
});
</script>

<style>
html {
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, sans-serif;
  font-size: 16px;
  word-spacing: 1px;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
}

.button--green {
  display: inline-block;
  border-radius: 4px;
  border: 1px solid #3b8070;
  color: #3b8070;
  text-decoration: none;
  padding: 10px 30px;
}

.button--green:hover {
  color: #fff;
  background-color: #3b8070;
}

.button--grey {
  display: inline-block;
  border-radius: 4px;
  border: 1px solid #35495e;
  color: #35495e;
  text-decoration: none;
  padding: 10px 30px;
  margin-left: 15px;
}

.button--grey:hover {
  color: #fff;
  background-color: #35495e;
}
</style>
